import { render, staticRenderFns } from "./mallShopDialog.vue?vue&type=template&id=56b861a4&scoped=true"
import script from "./mallShopDialog.vue?vue&type=script&lang=js"
export * from "./mallShopDialog.vue?vue&type=script&lang=js"
import style0 from "./mallShopDialog.vue?vue&type=style&index=0&id=56b861a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b861a4",
  null
  
)

export default component.exports